/* eslint-disable */
import React, { useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import KnittingToolsChart from './KnittingToolsChart';
import CrochetHooksChart from './CrochetHooksChart';

export default function ToolsChart() {
  const knittingSaveRef = useRef<(() => Promise<{ added: number[]; removed: number[] }>) | null>(null);
  const crochetSaveRef = useRef<(() => Promise<{ added: number[]; removed: number[] }>) | null>(null);

  const handleSave = async () => {
    try {
      // Save both knitting needles and crochet hooks
      const promises: Promise<{ added: number[]; removed: number[] }>[] = [];
      if (knittingSaveRef.current) {
        promises.push(knittingSaveRef.current());
      }
      if (crochetSaveRef.current) {
        promises.push(crochetSaveRef.current());
      }

      await Promise.all(promises);
      alert('Changes saved!');
    } catch (error) {
      console.error('Save failed:', error);
      alert('Error saving changes');
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" component="h1" sx={{ mb: 1, mt: 2, px: 2, fontWeight: 600 }}>
        Tools
      </Typography>
      
      <Box sx={{ mb: 4 }}>
        <KnittingToolsChart onSaveRef={knittingSaveRef} showSaveButton={false} />
      </Box>
      
      <Box sx={{ mt: 4 }}>
        <CrochetHooksChart onSaveRef={crochetSaveRef} showSaveButton={false} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Button 
          variant="contained" 
          onClick={handleSave} 
          sx={{ 
            m: { xs: 1, sm: 2 },
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          Save Changes
        </Button>
      </Box>
    </Box>
  );
}

